import React, { createContext, useState } from "react";

const initialState = {};

export const ProductFinderContext = createContext(null);

let types = [
    'car', 
    'suv', 
    'truck', 
    'van', 
    'motorcycle', 
    'scooter',
    'boat', 
    'bimini-tops', 
    'atv', 
    'utv', 
    'snowmobile', 
    'jet-ski', 
    'pontoon'
]

const useProductFinder = () => {
    const [productFinder, setProductFinder] = useState(initialState);
    const [errorField, _setErrorField] = useState(null);
    const [errorFieldRefresher, setErrorFieldRefresher] = useState(0);
    const [subtype, _setSubtype] = useState(null);

    
    function setSubtype(subtype) {
        let newSubtype = subtype?.replace('-covers-landing','')?.replace('-covers','') || null;
        
        if(newSubtype === 'car') newSubtype = null;
        
        _setSubtype(newSubtype);
    }

    function setErrorField(errorField) {
        _setErrorField(errorField);
        setErrorFieldRefresher((prev) => prev + 1);
    }

    return { productFinder, setProductFinder, errorField, setErrorField, errorFieldRefresher, subtype, setSubtype };
};

const ProductFinderProvider = ({ children }) => {
    const productFinder = useProductFinder();
    return (
        <ProductFinderContext.Provider value={productFinder}>
            {children}
        </ProductFinderContext.Provider>
    );
};

export default ProductFinderProvider;
